module.exports = __webpack_public_path__ + "img/sms-1-2.b35ab957.png";